// @flow

import React, { type Node } from 'react';
import { Button } from '@tectonics/look-and-feel/uber-v2/atoms';
import { useCopyToClipboard } from './use-copy';
import styled, { css } from 'styled-components';

type Props = {
  copiedMessage: Node,
  copyMessage: Node,
  value: string,
};

export function CopyToClipboardButton({ copyMessage, copiedMessage, value }: Props): Node {

  const [Clipboard, copied, handleClick] = useCopyToClipboard();

  return (
    <Root
      type="primary"
      as={Clipboard}
      onClick={handleClick}
      data-clipboard-text={value}
      copied={copied}
      size="lg"
      block
    >
      {copied ? copiedMessage : copyMessage}
    </Root>
  );
}

const Root = styled(Button)`
  position: relative;
  text-transform: uppercase;
  margin: auto;
  width: 100%;
  border: none;
  border-radius: 6px;
  outline: none;
  color: white;
  font-size: 1.2em;
  font-weight: 600;
  padding: 1em 0.5em;
  filter: brightness(115%);
  ${props => props.copied && css `
    background-color:hsla(119,32%,50%,1);
  `};
  ${props => !props.copied && css `
    background-color: black;
  `};
`;
